<template>
    <div v-if="loading||ecConfig">
        <vue-echart v-if="ecConfig" :white-mode="whiteMode" :config="!loading&&ecConfig" :height="height" :update-options="{notMerge:!enableMerge}"></vue-echart>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
    </div>
</template>

<script>
import VueEchart from "@/components/VueEchart";
import LoadingProgressBar from "../LoadingProgressBar";
import {callAPI} from '@/helper'
import * as echarts from 'echarts';
import 'echarts-gl';
import data3Processor from "../mixins/data3Processor";

export default {
    props: {
        whiteMode: {type: Boolean, default: false},
        enableMerge:{type: Boolean, default: false},
        parameters: {type: Object, default: null},
        equipment: {type:String, default: null},
        height: {type: Number, default: 300},
        timer: {type: Number, default: 5},
        animationMode: {type: Boolean, default: false},
        dateRange: {type: Object, default: null},
        data3query: {
            type: Object, default:null
        },
        processorFunction:{type: String, default: null},
    },
    components: {VueEchart,LoadingProgressBar},
    mixins:[data3Processor],
    computed: {
        ecConfig(){
            if (!this.config){
                return null
            } else if (this.animationMode){
                return this.config[this.configIndex]
            } else {
                return this.config
            }
        }
    },
    name: 'CustomEcWidget',
    data: function () {
        return {
            interval:null,
            configIndex:0,
            config:null,
            loading:false,
            timeout:null,
        }
    },
    beforeDestroy: function(){
        clearInterval(this.interval)
    },
    watch: {
        dateRange () {
            if (this.data3query) {
                this.refresh()
            }
        },
        equipment () {
            if (this.data3query) {
                this.refresh()
            }
        },
        parameters:{
            handler() {
                if(this.data3query){
                    this.refresh()
                }
            },
            deep: true,
            immediate: true,
        },
    },
    mounted: function(){
        this.refresh()
    },
    methods: {
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout= setTimeout(() => callback(), wait);
        },
        refresh(){
            this.debounce(this.getData,500);
        },
        incConfig() {
            if (this.configIndex < this.config.length - 1) {
                this.configIndex += 1;
            } else {
                clearInterval(this.interval)
                this.interval = null
            }
        },
        async getData(){
            clearInterval(this.interval)
            this.loading=true
            this.config=null
            let data = {}
            if (this.data3query) {
                let payloadArray = JSON.parse(JSON.stringify(this.data3query['data-payload']))
                payloadArray = payloadArray.filter(x => x.filters && (x.filters.sensor_name || x.filters.equipment_name))
                for (let payload of payloadArray) {
                    payload.parameters=this.parameters
                    this.processDateRange(payload, this.dateRange)
                    if (!payload.filters.facility_name && this.$store.state.pointsListStore.pointsList.facility_name) {
                        payload.filters.facility_name = this.$store.state.pointsListStore.pointsList.facility_name
                    }
                    if(this.equipment){
                        this.processEquipment(payload, this.equipment)
                    }
                    if (payload.onOnly) {
                        if (!payload.pipeline) {
                            payload.pipeline = []
                        }
                        payload.pipeline.unshift(
                            {
                                "type": "filter",
                                "filter_op": "eq",
                                "filter_by": "* - on",
                                "filter_value": 1,
                            }
                        )
                    }
                }
                let promises = payloadArray.map(payload => callAPI('data3/', payload))
                let results = await Promise.all(promises)
                for (let result of results) {
                    for (let seriesIndex in result.data) {
                        if (!data[seriesIndex]) {
                            data[seriesIndex] = result.data[seriesIndex]
                        }
                    }
                }
                if (Object.keys(data).length<2){
                    this.loading=false
                    this.config=null
                    return
                }
            }
            if (this.processorFunction&&this.processorFunction!==""){
                try {
                    let processData=eval(this.processorFunction)
                    this.config=processData(data,echarts)
                } catch (error) {
                    this.loading=false
                    this.config=null
                    return
                }
                if (this.animationMode&&this.config&&this.timer){
                    let me =this
                    me.interval=setInterval(function() { me.incConfig() }, this.timer*1000);
                }
            }
            this.loading=false
        }
    }
}

</script>

<style scoped>

</style>
